import { useState } from 'react'
import {
  StackLayout,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  CardSubtitle,
  GridLayout,
  GridLayoutItem
} from '@progress/kendo-react-layout'
import { Button, ButtonGroup } from '@progress/kendo-react-buttons'
import { Window } from '@progress/kendo-react-dialogs'
import './Supplier.css'
import { ConfirmDialog, ErrorMessage } from '../../../components/parts'
import { SearchResult } from '@gateway.maintenance'
import { CommonActions, SupplierSearchActions, useAppDispatch, useAppSelector } from '../../../stores'
import { SupplierItemDeleteGateway } from '../../../gateway/maintenance/SupplierItemDeleteGateway'
import { SupplierListGateway } from '../../../gateway/maintenance/SupplierListGateway'
import { SupplierInput } from './SupplierInput'
import { MessageProvider } from '../../../services'
import { Authority } from '../../../gateway/system/Authority'

interface SupplierResultListProps {
  skip: number
  setNotificationMessages: React.Dispatch<React.SetStateAction<ErrorMessage[]>>
  setErrorMessages: React.Dispatch<React.SetStateAction<ErrorMessage[]>>
  setSkip: React.Dispatch<React.SetStateAction<number>>
  target: string
  setTarget: React.Dispatch<React.SetStateAction<string>>
}

export const SupplierResultList = (props: SupplierResultListProps) => {
  const userProp = useAppSelector((state) => state.common.userProp)
  const searchResult = useAppSelector(
    (state) => state.supplierSearch.searchResult
  )
  const [showMaintenanceDialog, setShowMaintenanceDialog] = useState(false)
  const [dialogTitle, setDialogTitle] = useState('')
  const [isAddSupplierBranchMode, setIsAddSupplierBranchMode] = useState(false)
  // 修正中のデータ
  const [mutationSupplier, setMutationSupplier] = useState<SearchResult>()
  /* Dialog */
  const [confirmDialogShow, setConfirmDialogShow] = useState(false)
  const [confirmEditDialogGoBackShow, setConfirmEditDialogGoBackShow] = useState(false)

  // const common = useAppSelector((x) => x.common)
  // const codeBranchNames = common.initialData.codeNames('SI01')

  // 工務権限以外の判定フラグ
  const isNotBuilderAuthority = userProp?.authority !== Authority.Builder

  const dispatch = useAppDispatch()

  const searchCondation = useAppSelector(
    (state) => state.supplierSearch.searchCondation
  )

  const toggleMaintenanceDialog = () => {
    setShowMaintenanceDialog(!showMaintenanceDialog)
  }

  const confirmRegistDialogGoBackBtn = () => {
    setShowMaintenanceDialog(false)
    setConfirmEditDialogGoBackShow(false)
  }

  /**
   * 修正ボタン押下
   */
  const handleClickUpdateBtn = (supplier: SearchResult) => {
    setIsAddSupplierBranchMode(false)
    setDialogTitle('業者マスタメンテナンス　編集')
    toggleMaintenanceDialog()
    setMutationSupplier(supplier)
    props.setTarget(`${supplier.supplierCd ?? ''}-${supplier.supplierBranchCd ?? ''}`)
  }

  /**
   * 業者支店追加ボタン押下
   */
  const handleClickBranchAddBtn = (supplier: SearchResult) => {
    setIsAddSupplierBranchMode(true)
    setDialogTitle('業者マスタメンテナンス　業者支店追加')
    toggleMaintenanceDialog()
    // supplierCd,supplierNm以外を初期化する
    const copied: SearchResult = {
      ...supplier,
      supplierBranchCd: '',
      supplierBranchNm: '',
      supplierPerson: '',
      affiliationContacts: '',
      expense: '',
      displayOrder: 0,
      updDtmSupplier: '',
      updDtmBranch: '',
      updDtmExpense: '',
      updDtmFactory: '',
      updDtmPerson: ''
    }
    setMutationSupplier(copied)
    props.setTarget(`${supplier.supplierCd ?? ''}-${supplier.supplierBranchCd ?? ''}`)
  }

  /**
   * 削除ボタン押下
   */
  const handleClickDeleteBtn = (supplier: SearchResult) => {
    setMutationSupplier(supplier)
    setConfirmDialogShow(true)
    props.setTarget(`${supplier.supplierCd ?? ''}-${supplier.supplierBranchCd ?? ''}`)
  }

  /**
   * 削除イベント
   */
  const handleConfirmEvent = () => {
    dispatch(CommonActions.setIsLoading(true))
    SupplierItemDeleteGateway.deleteSupplierSearchItem({
      supplierCd: mutationSupplier?.supplierCd ?? '',
      supplierNm: mutationSupplier?.supplierNm ?? '',
      supplierBranchCd: mutationSupplier?.supplierBranchCd ?? '',
      supplierBranchNm: mutationSupplier?.supplierBranchNm ?? '',
      updDtmSupplier: mutationSupplier?.updDtmSupplier ?? '',
      UpdDtmSupplierBranch: mutationSupplier?.updDtmBranch ?? ''
    })
      .then((res) => {
        if (!res.error) {
          props.setNotificationMessages([{
            id: 'I004',
            content: MessageProvider.provide('I004', '削除処理')
          }])
          dispatch(CommonActions.setIsLoading(true))
          SupplierListGateway.fetchSupplierSearchList(searchCondation)
            .then((response) => {
              if (!response.error) {
                dispatch(SupplierSearchActions.setSearchResult(response.data.infoList))
                props.setSkip(props.skip)
              } else {
                if (Array.isArray(res.messages) && res.messages.length > 0) {
                  const errorMessages = res.messages.map<ErrorMessage>((message) => {
                    return {
                      id: message.id,
                      content: message.message
                    }
                  })
                  props.setErrorMessages(errorMessages)
                }
              }
            })
            .finally(() => { dispatch(CommonActions.setIsLoading(false)) })
        } else {
          if (Array.isArray(res.messages) && res.messages.length > 0) {
            const errorMessages = res.messages.map<ErrorMessage>((message) => {
              return {
                id: message.id,
                content: message.message
              }
            })
            props.setErrorMessages(errorMessages)
          }
        }
      })
      .finally(() => { dispatch(CommonActions.setIsLoading(false)) })
    setConfirmDialogShow(false)
  }

  return (
    <>
      <StackLayout orientation="vertical" gap={5}>
        {searchResult.slice(props.skip, props.skip + 20).map((item) => {
          // 支店ユーザかつ自支店以外の判定フラグ
          // const branchCd = codeBranchNames.find((x) => x.NAME === item.branchNm)?.CODE ?? ''
          // const isNotOwnBranch = (userProp?.authority === Authority.Branch && userProp?.branchCode !== branchCd)
          const key = `${item.supplierCd}-${item.supplierBranchCd}`

          return (
            <Card
              orientation="horizontal"
              key={key}
              className={
                props.target === `${item.supplierCd ?? ''}-${item.supplierBranchCd ?? ''}` ? 'target-card-body' : ''
              }
            >
              <CardHeader className='card-header'>
                <CardTitle>
                  <span
                    style={{
                      fontSize: '1.5em',
                      fontWeight: 'bold',
                      color: 'gray'
                    }}
                  >
                    {item.supplierNm}
                  </span>
                  <span
                    style={{
                      fontSize: '1.2em',
                      fontWeight: 'bold',
                      color: 'gray'
                    }}
                  >
                    {' '}{item.supplierBranchNm}
                  </span>
                </CardTitle>
                <CardSubtitle>
                  <GridLayout
                    rows={[{ height: 25 }]}
                    cols={[{ width: 50 }, { width: 125 }, { width: 100 }, { width: 100 }]}
                    gap={{ rows: 0, cols: 0 }}
                  >
                    <GridLayoutItem
                      col={1}
                      row={1}
                      style={{ textAlign: 'start' }}
                    >
                      {item.branchNm}
                    </GridLayoutItem>
                    <GridLayoutItem
                      col={2}
                      row={1}
                      style={{ textAlign: 'start' }}
                    >
                      {item.supplierCd}
                    </GridLayoutItem>
                    <GridLayoutItem
                      col={3}
                      row={1}
                      style={{ textAlign: 'start' }}
                    >
                      {item.supplierPerson}
                    </GridLayoutItem>
                    <GridLayoutItem
                      col={4}
                      row={1}
                      style={{ textAlign: 'start' }}
                    >
                      {item.affiliationContacts}
                    </GridLayoutItem>
                  </GridLayout>
                </CardSubtitle>
              </CardHeader>

              <CardBody className='card-body'>
                <GridLayout
                  rows={[{ height: 50 }, { height: 25 }]}
                  cols={[{ width: 350 }, { width: 100 }]}
                  gap={{ rows: 5, cols: 10 }}
                  align={{ vertical: 'middle' }}
                >
                  <GridLayoutItem
                    col={1}
                    row={1}
                    rowSpan={2}
                    style={{ textAlign: 'start' }}
                  >
                    <span style={{ fontWeight: 'normal', fontSize: '0.9em' }}>
                      {item.expense}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem
                    col={2}
                    row={1}
                    style={{ textAlign: 'center' }}
                  >
                    <span style={{ fontWeight: 'normal', fontSize: '1.5em' }}>
                      {item.displayOrder ?? '-'}
                    </span>
                  </GridLayoutItem>
                  <GridLayoutItem
                    col={2}
                    row={2}
                    style={{ textAlign: 'center' }}
                  >
                    <ButtonGroup>
                      <Button
                        themeColor="secondary"
                        fillMode="flat"
                        onClick={() => handleClickUpdateBtn(item)}
                        style={{ marginLeft: '5px' }}
                      >
                        修正
                      </Button>
                      <Button
                        themeColor="secondary"
                        fillMode="flat"
                        onClick={() => handleClickBranchAddBtn(item)}
                        style={{ marginLeft: '5px' }}
                        disabled={isNotBuilderAuthority}
                      >
                        業者支店追加
                      </Button>
                      <Button
                        themeColor="secondary"
                        fillMode="flat"
                        onClick={() => handleClickDeleteBtn(item)}
                        disabled={isNotBuilderAuthority}
                      >
                        削除
                      </Button>
                    </ButtonGroup>
                  </GridLayoutItem>
                </GridLayout>
              </CardBody>
            </Card>
          )
        })}
      </StackLayout>

      {showMaintenanceDialog && (
        <Window
          title={dialogTitle}
          onClose={() => setConfirmEditDialogGoBackShow(true)}
          initialWidth={1280}
          initialHeight={500}
          modal
        >
          <SupplierInput
            searchResult={mutationSupplier}
            setShowMaintenanceDialog={setShowMaintenanceDialog}
            setNotificationMessages={props.setNotificationMessages}
            setErrorMessages={props.setErrorMessages}
            skip={props.skip}
            setSkip={props.setSkip}
            isFixMode={!isAddSupplierBranchMode}
            isAddSupplierBranchMode={isAddSupplierBranchMode}
          />
          <div
            style={{
              marginTop: '10px',
              display: 'flex',
              justifyContent: 'flex-end'
            }}
          />
        </Window>
      )}
      {confirmDialogShow && (
        <ConfirmDialog
          open={confirmDialogShow}
          title={'削除'}
          id={'I002'}
          args={[`${mutationSupplier?.supplierNm ?? ''}のデータ`, '全て削除']}
          onClickOk={handleConfirmEvent}
          onClickCancel={() => setConfirmDialogShow(false)}
        />
      )}
      {confirmEditDialogGoBackShow && (
        <ConfirmDialog
          title="戻る"
          open={confirmEditDialogGoBackShow}
          renderCloseButton
          id={'I003'}
          args={['戻る']}
          onClickOk={confirmRegistDialogGoBackBtn}
          onClickCancel={() => setConfirmEditDialogGoBackShow(false)}
        />
      )}
    </>
  )
}
